import clsx from 'clsx';
import React from 'react';
import { ReactComponent as EmailBase } from './emailIcon.svg';
import { ReactComponent as LoginLogo } from './loginIcon.svg';
import { ReactComponent as PasswordBase } from './passwordIcon.svg';

// Brand icons use fill="currentColor"; this wrapper injects the central
// `.brand-icon` colour (driven by @primary-color) on every render.
const withBrandColor = (Icon) => {
  const BrandIcon = (props) => (
    <Icon {...props} className={clsx('brand-icon', props?.className)} />
  );
  return BrandIcon;
};

const Email = withBrandColor(EmailBase);
const Password = withBrandColor(PasswordBase);

export { LoginLogo, Email, Password };
